"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Devices = require("./Devices");

var _FormPreview = _interopRequireDefault(require("../../views/FormPreview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectView = function selectView(type) {
  switch (type) {
    case "desktop":
      return _Devices.DesktopView;

    case "tablet":
      return _Devices.TabletView;

    case "mobile":
      return _Devices.MobileView;

    default:
      return window.location.href = "/form/create";
  }
};

var DeviceView = function DeviceView(props) {
  var View = selectView(props.match ? props.match.params.device : props.device);
  console.log('Device view props ===>', props);
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(_FormPreview.default, props)));
};

var _default = DeviceView;
exports.default = _default;